/* @flow strict */

/* eslint-disable camelcase */

import _ from 'lodash';

const exampleDataTop5 = (): void => {
  const _d = [];
  const itemCount = 5;

  for (let i = 0; i < itemCount; i++) {
    _d.push(
      {
        referral_user_name: `Sample ${i + 1}`,
        view_count: _.random(1, 10),
        amount: _.random(100, 10000),
        amount_refund: 0
      }
    );
  }

  return _d;
};
const exampleDataBreakDown = (): void => {
  const _d = [];
  const itemCount = 3;

  for (let i = 0; i < itemCount; i++) {
    _d.push(
      {
        ticket_name: `Sample ${i + 1}`,
        merchant_revenue: _.random(1000, 10000),
        merchant_revenue_refund: _.random(100, 1000)
      }
    );
  }

  return _d;
};
const exampleDataTicketsRevenue = (): void => {
  const _d = [];
  const itemCount = _.random(1, 3);

  for (let i = 0; i < itemCount; i++) {
    _d.push(
      {
        ticket_name: `Sample ${i + 1}`,
        sold_quantity: _.random(10, 100),
        merchant_revenue: _.random(1000, 10000),
        merchant_revenue_refund: _.random(100, 1000),
        return_quantity: _.random(1, 10),
        stock_quantity: 100
      }
    );
  }

  return _d;
};
const exampleDataTicketsDonation = (): void => {
  const _d = [];
  const itemCount = 1;

  for (let i = 0; i < itemCount; i++) {
    _d.push(
      {
        amount: _.random(1000, 1500),
        amount_refund: _.random(50, 100),
        merchant_revenue: _.random(1000, 1500),
        merchant_revenue_refund: _.random(50, 100),
        donationGoal: _.random(1300, 1600)
      }
    );
  }

  return _d;
};
const exampleDataTicketSales = (): void => {
  const _d = [];
  const itemCount = _.random(2, 15);

  for (let i = 0; i < itemCount; i++) {
    _d.push(
      {
        name: 'Example Date',
        uv: _.random(5, 20),
        pv: _.random(5, 20),
        amt: _.random(5, 20),
        lv: _.random(5, 20)
      }
    );
  }

  return _d;
};

export const mockData = {
  StatsTop5: exampleDataTop5(),
  BreakDown: exampleDataBreakDown(),
  TicketsRevenue: exampleDataTicketsRevenue(),
  TicketsDonation: exampleDataTicketsDonation(),
  TicketSales: exampleDataTicketSales(),
  TicketTotalQuality: {
    sold_quantity:_.random(10, 50),
    return_quantity: _.random(0, 10),
    merchant_revenue: _.random(1000, 1500),
    merchant_revenue_refund: _.random(500, 1000),
    stock_quantity: _.random(50, 100),
    price: _.random(100, 1000)
  }
};
